
import { background, color } from "@chakra-ui/system";
import { CONSTANTS } from "config/constant";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { useTranslation } from "react-i18next";

const ViewArea = () => {
  const { t } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state && location.state.data;
  function truncateText(text, maxLength) {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }

  return (
    <div className="flex gap-8">
      <div style={styles.container} className="min-h-[37rem]">
        <table style={styles.table}>
          <tbody>
            <div
              className="flex cursor-pointer items-center gap-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MdOutlineArrowBack
                className="cursor-pointer"
                style={{ fontSize: "17px" }}
              />
              <p>Back</p>
            </div>
            <p className="mb-4 text-center text-[20px] font-semibold">
              View Area
            </p>
            <hr className="mb-4" />
            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}>
                  {t("Area Country")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.city}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Area City")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.city}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("SubArea")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.sub_area}
                </td>
              </tr>
            </div>
          </tbody>
        </table>
      </div>
    </div>
  );
};
const styles = {
  container: {
    margin: "auto",
    width: "80%",
    padding: "20px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
  },
  label: {
    paddingRight: "10px",
    verticalAlign: "top",
    padding: "1rem",
  },
};

export default ViewArea;
